import { render, staticRenderFns } from "./AdyenCardForm.vue?vue&type=template&id=5225279c"
import script from "./AdyenCardForm.vue?vue&type=script&lang=js"
export * from "./AdyenCardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports